// extracted by mini-css-extract-plugin
export default {"paragraph":"styles_paragraph__bZEOM","dot":"styles_dot__c1ZXu"};